import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function GuideSection() {
  const [isGuideLoaded, setIsGuideLoaded] = useState(false);
  const { FiPlay } = FiIcons;

  return (
    <motion.section 
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.2, duration: 0.8 }}
      className="relative z-10 px-0 sm:px-4"
    >
      <div className="max-w-6xl mx-auto">
        {/* Glow Effects */}
        <div className="absolute -top-20 -left-10 md:-top-40 md:-left-40 w-48 h-48 md:w-96 md:h-96 bg-glow-purple/20 rounded-full blur-[60px] md:blur-[120px] pointer-events-none"></div>
        <div className="absolute -bottom-20 -right-10 md:-bottom-40 md:-right-40 w-48 h-48 md:w-96 md:h-96 bg-glow-cyan/20 rounded-full blur-[60px] md:blur-[120px] pointer-events-none"></div>

        <div className="bg-[#1B2C5E]/40 backdrop-blur-3xl rounded-none sm:rounded-[2.5rem] p-6 md:p-12 border-y sm:border border-white/10 shadow-2xl relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-badge"></div>
          
          <div className="mb-8 md:mb-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div className="text-left">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">Interactive Buying Trade Guide</h3>
              <p className="text-sm md:text-lg text-[#B8C8E8] max-w-2xl">Master the fundamental signals and entry strategies in real-time.</p>
            </div>
            <div className="flex justify-start">
              <span className="px-5 py-2 bg-green-500/10 border border-green-500/20 text-green-400 text-[10px] md:text-xs font-bold uppercase tracking-widest rounded-full flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span>
                Status: Live Guide
              </span>
            </div>
          </div>

          <div 
            style={{
              position: 'relative',
              height: 0,
              width: '100%',
              overflow: 'hidden',
              zIndex: 40,
              borderRadius: '12px',
              boxSizing: 'border-box',
              paddingBottom: 'calc(46.92532943% + 32px)',
              background: '#050508'
            }}
            className="shadow-2xl border border-white/10 group/embed"
          >
            {!isGuideLoaded ? (
              <div 
                className="absolute inset-0 flex flex-col items-center justify-center bg-[#0A1628]/80 hover:bg-[#0A1628]/60 backdrop-blur-sm z-10 cursor-pointer transition-all duration-300" 
                onClick={() => setIsGuideLoaded(true)}
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-brand flex items-center justify-center shadow-[0_0_30px_rgba(232,75,48,0.4)] group-hover/embed:scale-110 transition-all duration-300">
                  <SafeIcon icon={FiPlay} className="text-3xl md:text-4xl text-white ml-2" />
                </div>
                <p className="mt-6 text-white font-bold tracking-widest uppercase text-xs md:text-sm animate-pulse text-center px-6">
                  Click to Load Interactive Buying Guide
                </p>
              </div>
            ) : (
              <iframe 
                src="https://www.guidejar.com/embed/b5821446-19e8-478a-88d5-bf91b92c1ddc?type=1&controls=on" 
                width="100%" 
                height="100%" 
                style={{ position: 'absolute', inset: 0 }} 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
                allowFullScreen 
                frameBorder="0"
                title="ProfitLense Buying Trade Guide"
              ></iframe>
            )}
          </div>

          <div className="mt-10 md:mt-14 flex flex-wrap items-center justify-center gap-x-10 md:gap-x-16 gap-y-6">
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#E8366E] shadow-[0_0_12px_rgba(232,54,110,0.5)]"></div>
              <span className="text-[10px] md:text-xs text-[#B8C8E8] font-bold uppercase tracking-widest">Entry Logic</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#1E90FF] shadow-[0_0_12px_rgba(30,144,255,0.5)]"></div>
              <span className="text-[10px] md:text-xs text-[#B8C8E8] font-bold uppercase tracking-widest">Confirmation Rules</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 rounded-full bg-[#E84B30] shadow-[0_0_12px_rgba(232,75,48,0.5)]"></div>
              <span className="text-[10px] md:text-xs text-[#B8C8E8] font-bold uppercase tracking-widest">Exit Strategy</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}